import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const TierManagement = () => {
  const [tiers, setTiers] = useState([]);

  useEffect(() => {
    fetchTiers();
  }, []);

  const fetchTiers = async () => {
    // Mock data
    const mockTiers = [
      {
        id: 1,
        name: 'Bronze',
        pointsRequired: 0,
        color: '#cd7f32',
        benefits: ['Basic rewards access', 'Monthly newsletter', 'Birthday bonus'],
        memberCount: 456
      },
      {
        id: 2,
        name: 'Silver',
        pointsRequired: 2500,
        color: '#c0c0c0',
        benefits: ['Priority class booking', 'Free guest passes (2/month)', '10% merchandise discount', 'All Bronze benefits'],
        memberCount: 523
      },
      {
        id: 3,
        name: 'Gold',
        pointsRequired: 5000,
        color: '#ffd700',
        benefits: ['VIP locker access', 'Free personal training (1/month)', '20% merchandise discount', 'Exclusive events', 'All Silver benefits'],
        memberCount: 268
      }
    ];
    setTiers(mockTiers);
  };

  return (
    <div className="space-y-6">
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl font-heading font-semibold text-foreground mb-1">
              Membership Tier Management
            </h2>
            <p className="text-sm text-muted-foreground">
              Configure tier levels, thresholds, and exclusive benefits
            </p>
          </div>
          <Button iconName="Plus">
            Add Tier
          </Button>
        </div>

        <div className="space-y-4">
          {tiers?.map((tier, index) => (
            <div
              key={tier?.id}
              className="p-6 rounded-lg border-2 transition-all duration-250"
              style={{ borderColor: `${tier?.color}40`, backgroundColor: `${tier?.color}08` }}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-4">
                  <div
                    className="w-16 h-16 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: `${tier?.color}20` }}
                  >
                    <Icon
                      name={index === 0 ? 'Award' : index === 1 ? 'Medal' : 'Trophy'}
                      size={32}
                      color={tier?.color}
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-heading font-bold text-foreground mb-1">
                      {tier?.name} Tier
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {tier?.pointsRequired === 0
                        ? 'Starting tier'
                        : `${tier?.pointsRequired?.toLocaleString()} points required`}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-heading font-bold text-foreground">
                    {tier?.memberCount}
                  </p>
                  <p className="text-xs text-muted-foreground">members</p>
                </div>
              </div>

              <div className="mb-4">
                <h4 className="text-sm font-medium text-foreground mb-2">Exclusive Benefits:</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {tier?.benefits?.map((benefit, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <Icon name="CheckCircle" size={16} color="var(--color-success)" className="mt-0.5" />
                      <span className="text-sm text-muted-foreground">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex gap-2">
                <Button variant="outline" size="sm" iconName="Edit">
                  Edit Tier
                </Button>
                <Button variant="outline" size="sm" iconName="Settings">
                  Configure Benefits
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tier Progression Visualization */}
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Tier Progression Path
        </h2>
        <div className="relative">
          <div className="flex items-center justify-between">
            {tiers?.map((tier, index) => (
              <div key={tier?.id} className="flex-1 text-center">
                <div
                  className="w-16 h-16 rounded-full mx-auto mb-2 flex items-center justify-center"
                  style={{ backgroundColor: `${tier?.color}20` }}
                >
                  <Icon
                    name={index === 0 ? 'Award' : index === 1 ? 'Medal' : 'Trophy'}
                    size={28}
                    color={tier?.color}
                  />
                </div>
                <p className="font-semibold text-foreground text-sm">{tier?.name}</p>
                <p className="text-xs text-muted-foreground">
                  {tier?.pointsRequired?.toLocaleString()} pts
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TierManagement;